import i18n from "../i18n";

export const getMonthByIndex = (
  month: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12,
  shortMonth?: boolean,
) => {
  const prefix = shortMonth ? "shortMonth" : "month";
  switch (month) {
    case 1:
      return i18n.t(`${prefix}.jan`);
    case 2:
      return i18n.t(`${prefix}.feb`);
    case 3:
      return i18n.t(`${prefix}.mar`);
    case 4:
      return i18n.t(`${prefix}.apr`);
    case 5:
      return i18n.t(`${prefix}.may`);
    case 6:
      return i18n.t(`${prefix}.jun`);
    case 7:
      return i18n.t(`${prefix}.jul`);
    case 8:
      return i18n.t(`${prefix}.aug`);
    case 9:
      return i18n.t(`${prefix}.sept`);
    case 10:
      return i18n.t(`${prefix}.oct`);
    case 11:
      return i18n.t(`${prefix}.nov`);
    case 12:
      return i18n.t(`${prefix}.dec`);
    default:
      return "";
  }
};
